import { useState } from "react";
import './DropdownCompany.css'
import { useNavigate } from 'react-router-dom';
import capitalizeFirstLetter from "/src/utils/capitalizeFirstLetter";
import urlWithRoutingCompany from '/src/utils/urlWithRoutingCompany';
import userAction from "/src/features/user/actions/userAction";
import { useToastDispatchContext } from '/src/layouts/toast/context/toastContext';
const DropdownCompany = ({ prefix, companies }) => {
    const [isOpen, setIsOpen] = useState(false);

    const { changeCompany } = userAction;

    const naviguate = useNavigate();

    const toast = useToastDispatchContext();
    

    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    };

    const updateCompany = async (id) => {
        const res = await changeCompany(id);
        if (res.error != null) {
            console.error(res.error);
            return;
        }
        const { user, company } = res;
        toast.success('Congrats ' + user.username, 'You change your are now in' + company.name);
        naviguate(urlWithRoutingCompany('home'));
    };

    return (
        <>
            <div className="dropdown-company" onClick={toggleDropdown}>
                <div style={{display:'flex', gap:'0.5rem'}}>
                    <span>{capitalizeFirstLetter(prefix)}</span>
                    <div>({companies.length})</div>
                </div>
                <div>
                    {isOpen ? (
                        <i className="fa fa-chevron-up"></i>
                    ) : (
                        <i className="fa fa-chevron-down"></i> 
                    )}
                </div>
            </div>
            {isOpen && (
                <div className="dropdown-content">
                    {companies.map((company) => (
                        <DropdownItem key={company.id} {...company} updateCompany={updateCompany} />
                    ))}
                </div>
            )}
        </>
    );
};

const DropdownItem = ({ name, logo, id, updateCompany }) => {
    return (
        <div className="dropdown-company dropdown-item" onClick={() => updateCompany(id)}>
            <div style={{display: 'flex', gap:'1rem', alignItems:'center'}}>
                <div><img src={logo} /></div>
                <span style={{width: '180px'}}>{capitalizeFirstLetter(name)}</span>
            </div>
        </div>
    );
};

export default DropdownCompany;